import Script from 'next/script';

import { env } from '@/constant/env';

import {
  getTermlyScriptUrl,
  TERMLY_ORIGIN,
  TERMLY_ROOT_ID,
  TERMLY_SCRIPT_ID,
} from './constants';

export function getTermlyWebsiteUuid() {
  if (env.isVisualTest) return undefined;

  return env.publicTermlyWebsiteUuid || undefined;
}

export function TermlyScript() {
  const websiteUuid = getTermlyWebsiteUuid();

  if (!websiteUuid) return null;

  return (
    <>
      <link rel='preconnect' href={TERMLY_ORIGIN} />
      <Script
        id={TERMLY_SCRIPT_ID}
        strategy='beforeInteractive'
        src={getTermlyScriptUrl(websiteUuid)}
      />
    </>
  );
}

// Termly renders into this element before React hydrates; owning it keeps hydration clean.
export function TermlyRoot() {
  if (!getTermlyWebsiteUuid()) return null;

  return (
    <div
      id={TERMLY_ROOT_ID}
      suppressHydrationWarning={true}
      dangerouslySetInnerHTML={{ __html: '' }}
    />
  );
}
